export default __webpack_public_path__ + "media/images/badge-level3-size12-c2d0ca4777597c53d4facf236f44a9e3.png";